/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  CreateCustomizationRequest,
  Customization,
  DeleteAdminV1OrgCustomizationsIdPathParameters,
  GetAdminV1OrgCustomizations200,
  GetAdminV1OrgCustomizationsIdPathParameters,
  PatchAdminV1OrgCustomizationsIdPathParameters,
  UpdateCustomizationRequest
} from '../model';

import { customInstance } from '../../../transport/mutator';
import type { BodyType } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Customizations of the organization
 */
export const getAdminV1OrgCustomizations = (

 options?: SecondParameter<typeof customInstance<GetAdminV1OrgCustomizations200>>,) => {
      return customInstance<GetAdminV1OrgCustomizations200>(
      {url: `/admin/v1/org/customizations`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Create a customization. A select takes a size set or inline options; text takes maxLength and pattern; file takes accept.
 */
export const postAdminV1OrgCustomizations = (
    createCustomizationRequest: BodyType<CreateCustomizationRequest>,
 options?: SecondParameter<typeof customInstance<Customization>>,) => {
      return customInstance<Customization>(
      {url: `/admin/v1/org/customizations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCustomizationRequest
    },
      options);
    }
  /**
 * @summary Get a customization
 */
export const getAdminV1OrgCustomizationsId = (
    { id }: GetAdminV1OrgCustomizationsIdPathParameters,
 options?: SecondParameter<typeof customInstance<Customization>>,) => {
      return customInstance<Customization>(
      {url: `/admin/v1/org/customizations/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update a customization. Passing options replaces the whole list; the input type never changes.
 */
export const patchAdminV1OrgCustomizationsId = (
    { id }: PatchAdminV1OrgCustomizationsIdPathParameters,
    updateCustomizationRequest: BodyType<UpdateCustomizationRequest>,
 options?: SecondParameter<typeof customInstance<Customization>>,) => {
      return customInstance<Customization>(
      {url: `/admin/v1/org/customizations/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCustomizationRequest
    },
      options);
    }
  /**
 * @summary Delete a customization no product or product type uses
 */
export const deleteAdminV1OrgCustomizationsId = (
    { id }: DeleteAdminV1OrgCustomizationsIdPathParameters,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/v1/org/customizations/${id}`, method: 'DELETE'
    },
      options);
    }
  export type GetAdminV1OrgCustomizationsResult = NonNullable<Awaited<ReturnType<typeof getAdminV1OrgCustomizations>>>
export type PostAdminV1OrgCustomizationsResult = NonNullable<Awaited<ReturnType<typeof postAdminV1OrgCustomizations>>>
export type GetAdminV1OrgCustomizationsIdResult = NonNullable<Awaited<ReturnType<typeof getAdminV1OrgCustomizationsId>>>
export type PatchAdminV1OrgCustomizationsIdResult = NonNullable<Awaited<ReturnType<typeof patchAdminV1OrgCustomizationsId>>>
export type DeleteAdminV1OrgCustomizationsIdResult = NonNullable<Awaited<ReturnType<typeof deleteAdminV1OrgCustomizationsId>>>
